// extracted by mini-css-extract-plugin
export default {"wrapper":"CourseProgressTypeCell_wrapper__bPFxk"};